import EventEmitter from "eventemitter3";

const USE_COLOR = false;
export default class ViewCanvas extends EventEmitter {
  constructor(url, asset_id, verso, useWorker = true, useBiggerSize = false) {
    super();
    // check if we are in the modern version
    if (document.body.classList.contains("modern")) this.isModern = true;
    // console.log(verso);
    this.domElement = document.createElement("div");

    // console.log("IS USING COLOR", USE_COLOR);

    // add wrapper to carry 2 images
    const imagesWrapper = document.createElement("div");
    imagesWrapper.classList.add("imagesWrapper");
    imagesWrapper.classList.add(Math.random() > 0.5 ? "left" : "right");
    imagesWrapper.setAttribute("data-transition", "zoomed");
    imagesWrapper.setAttribute("data-verso", verso);

    this.domElement.appendChild(imagesWrapper);
    this.src = useWorker
      ? `${url}=s5`
      : url + useBiggerSize
      ? `${url}=s1024`
      : url;
    this.imagesWrapper = imagesWrapper;

    this.image = new Image();
    this.imagesWrapper.appendChild(this.image);

    // add color image on top overlay
    if (USE_COLOR) {
      this.colorImage = new Image();
      this.colorImage.classList.add("colored");
      if (this.isModern) this.colorImage.classList.add("persistent");
      this.colorImage.src = `./getImage/${asset_id}`;
      imagesWrapper.appendChild(this.colorImage);
    } else {
      this.image.classList.add("forceVisibility");
    }

    if (useWorker && !this.isModern) this.loadSmoothly(url, useBiggerSize);
    // return domElement;
  }

  load(onComplete, onError = null) {
    this.image.onload = (e) => {
      // console.table("\t\t image loaded");
      onComplete(e.target.src);
      // this.emit("loaded", [e.target.src]);
    };
    this.image.onerror = (e) => {
      if (onError != null) onError(e.target.src);
      // this.emit("error", [e.target.src]);
    };
    this.image.src = this.src;
  }

  get dom() {
    return this.domElement;
  }

  loadSmoothly(url, useBiggerSize = false) {
    const loaderWorker = new Worker(
      new URL("./workers/ImageLoaderWorker.js", import.meta.url)
    );
    loaderWorker.postMessage({ url: url + (useBiggerSize ? `=s1024` : ``) });
    loaderWorker.onmessage = (event) => {
      console.log("from worker", event.data);
      this.image.src = event.data;
    };
  }
}
